<template>
  <section>
    <h3 class="primary--text"><v-icon color="primary" style="vertical-align: middle">contact_phone</v-icon> {{ $util.isRol('ADMIN') ? 'Puntos de atención' : 'Punto de atención' }}</h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :widthModal="800"
        >
          <template slot="buttons">
            <v-tooltip bottom v-if="$store.state.permissions['puntos:create']">
              <v-btn color="primary"
                @click.native.stop="openModal()"
                slot="activator">
                <v-icon>add</v-icon> {{$t('common.add') }}
              </v-btn>
              <span>{{ 'Agregar nuevo punto de atención' }}</span>
            </v-tooltip>
          </template>

          <template slot="form">
            <v-card-title class="headline">
              <v-flex xs9>
                <v-icon>contact_phone</v-icon> {{ form.id ? 'Actualizar punto de atención' :  'Agregar punto de atención' }}
              </v-flex>
              <v-flex xs2 text-md-right>
                <v-chip label color="success" text-color="white" v-if="form.estado == 'ACTIVO'">
                  {{ form.estado }}
                </v-chip>
                <v-chip label color="warning" text-color="white" v-if="form.estado == 'INACTIVO'">
                  {{ form.estado }}
                </v-chip>
              </v-flex>
              <v-flex xs1 text-md-right>
                <v-btn small flat icon @click.native="$store.commit('closeModal')">
                  <v-icon class="red--text">cancel</v-icon>
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-form
              @submit.prevent="save"
              v-model="valid"
              ref="form"
              lazy-validation
              >
              <v-card-text class="pt-0">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs8>
                      <v-text-field
                        name="identificador"
                        label="Identificador de punto de atención"
                        id="identificador"
                        v-model="form.identificador"
                        autofocus
                        maxlength="150"
                        :rules="$validate(['required'])"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs8>
                      <v-autocomplete
                        :items="entidades"
                        v-model="form.id_entidad"
                        label="Entidad"
                        item-text="text"
                        item-value="value"
                        noDataText="No hay resultados"
                        :rules="$validate(['required'])"
                        required
                        ></v-autocomplete>
                    </v-flex>

                    <!-- <v-flex xs8>
                      <v-text-field
                        name="descripcion"
                        :label="$t('entity.crud.description')"
                        id="descripcion"
                        v-model="form.descripcion"
                        maxlength="500"
                        :counter="500"
                        :rules="$validate(['required'])"
                        required
                      ></v-text-field>
                    </v-flex> -->
                  </v-layout>

                  <v-flex xs12>
                    <v-combobox
                      label="Operadores autorizados"
                      chips
                      multiple
                      :items="operadores"
                      prepend-icon="person"
                      v-model="form.operadores_autorizados"
                      item-text="usuario"
                      item-value="id"
                      noDataText="No hay operadores"
                    >
                      <template slot="selection" slot-scope="data">
                        <v-chip
                          close
                          @input="removerOperador(data.item)"
                          :selected="data.selected"
                        >
                          {{ data.item.usuario }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-flex>

                  <v-flex xs12>
                    <v-combobox
                      label="Canales autorizados"
                      chips
                      multiple
                      :items="canales"
                      prepend-icon="share"
                      v-model="form.canales_autorizados"
                      item-text="usuario"
                      item-value="id"
                      noDataText="No hay canales"
                    >
                      <template slot="selection" slot-scope="data">
                        <v-chip
                          close
                          @input="removerCanal(data.item)"
                          :selected="data.selected"
                        >
                          {{ data.item.usuario }} / {{data.item.clasificacion}}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-flex>
                </v-container>
                <log-datos :data="logDatos" v-if="logDatos"></log-datos>
              </v-card-text>
              <v-card-actions>
                <small class="error--text text-required">* {{$t('common.required_fields')}}</small>
                <v-spacer></v-spacer>
                <v-btn flat color="red"
                  @click.native="$store.commit('closeModal');">
                  <v-icon>close</v-icon> {{$t('common.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  type="submit"
                  :disabled="!valid">
                  <v-icon>check</v-icon> {{$t('common.save') }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </template>

          <template slot="items" slot-scope="items">
            <td class="nowrap">
              <v-tooltip bottom v-if="$store.state.permissions['puntos:update']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="editItem(items.item.id, 'system/puntos', false)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <!-- <v-tooltip bottom v-if="$store.state.permissions['usuarios:update']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="generarToken('ENTIDAD', { id_entidad: items.item.id })">
                  <v-icon>vpn_key</v-icon>
                </v-btn>
                <span>Generar token para la entidad</span>
              </v-tooltip> -->
              <v-tooltip bottom v-if="$store.state.permissions['puntos:delete'] && $util.isRol('SUPERADMIN')">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="deleteItem(items.item.id, 'system/puntos')">
                  <v-icon color="red">delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            </td>
            <td>
              <v-tooltip bottom v-if="$store.state.permissions['puntos:update']">
                <v-switch
                  v-model="items.item.active"
                  value="ACTIVE"
                  @change="changeActive(items.item, items.item.id, 'system/puntos')"
                  hide-details
                  slot="activator"
                  color="success"></v-switch>
                <span>Activar/desactivar registro</span>
              </v-tooltip>
              <v-icon
                v-if="!$store.state.permissions['puntos:update']"
                :color="items.item.active === 'ACTIVE' ? 'success' : 'error'">
                {{ items.item.active === 'ACTIVE' ? 'check' : 'close' }}
              </v-icon>
            </td>
            <td>{{ items.item.identificador }}</td>
            <td>{{ items.item['entidad.nombre'] }}</td>
            <td>
              <v-chip label color="success" text-color="white" v-if="items.item.estado == 'ACTIVO'">
                {{ items.item.estado }}
              </v-chip>
              <v-chip label color="warning" text-color="white" v-if="items.item.estado == 'INACTIVO'">
                {{ items.item.estado }}
              </v-chip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import validate from '@/common/mixins/validate';
import token from '@/components/admin/modulo/mixins/token';
import LogDatos from '@/components/admin/usuario/LogDatos';
import logDatos from '@/components/admin/usuario/mixins/log-datos';
import usuario from '../usuario/mixins/usuario';
import puntoAtencion from './mixins/puntoAtencion';

export default {
  mixins: [ crud, validate, token, logDatos, usuario, puntoAtencion ],
  created () {
    this.user = this.$storage.getUser();
    this.idEntidad = this.user.id_entidad;
    this.idpunto = this.user.id_punto_atencion;
    this.entidades = [];
    this.getEntidades(0);
    this.canales = [];
    // this.getCanales(0);
    this.operadores = [];
    // this.getOperadores(0);
    this.recuperarCanales();
    this.recuperarOperadores();
  },
  mounted () {},
  data () {
    return {
      canales: [],
      operadores: [],
      logDatos: null,
      successAlert: false,
      graphql: false, // Definiendo el CRUD con Graphql
      url: 'system/puntos',
      headers: [
        { text: this.$t('common.actions'), sortable: false },
        { text: this.$t('common.active'), sortable: false },
        { text: this.$t('puntos_atencion.crud.identificador'), value: 'identificador' },
        { text: this.$t('puntos_atencion.crud.entidad'), value: 'entidad.nombre' },
        { text: this.$t('common.status'), value: 'estado' }
      ],
      form: {
        identificador: '',
        id_entidad: '',
        // descripcion: '',
        operadores_autorizados: [],
        canales_autorizados: [],
        estado: ''
      },
      dataGraphql: `
        id
        identificador
        id_entidad
        operadores_autorizados
        canales_autorizados
        estado
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      filters: [
        {
          field: 'identificador',
          label: this.$t('puntos_atencion.crud.identificador'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'entidad',
          label: this.$t('puntos_atencion.crud.entidad'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'estado',
          label: this.$t('common.status'),
          type: 'select',
          typeG: 'EstadoEntidad',
          items: [
            { value: '', text: 'TODOS' },
            { value: 'ACTIVO', text: 'ACTIVO' },
            { value: 'INACTIVO', text: 'INACTIVO' }
          ]
        }
      ],
      idPunto: null,
      idEntidad: null,
      valid: true
    };
  },
  methods: {
    recuperarCanales () {
      this.canales = [];
      this.$service.get(`system/canales?estado=ACTIVO`, {})
      .then(response => {
        if (response) {
          response.rows.forEach((item) => {
            this.canales.push({id: item.id, usuario: item.usuario, clasificacion: item.clasificacion});
          });
        }
      });
    },
    recuperarOperadores () {
      this.operadores = [];
      this.$service.get(`system/operadores?estado=ACTIVO`, {})
      .then(response => {
        if (response) {
          response.rows.forEach((item) => {
            this.operadores.push({id: item.id, usuario: item.usuario});
          });
        }
      });
    },
    openModal (data = {}, form = true) {
      console.log('------------------------------------');
      console.log(this.entidades);
      console.log('------------------------------------');
      this.valid = true;
      this.$refs.form.reset();
      this.logDatos = null;
      if (data.id) {
        // if (data.canales_autorizados) {
        //   data.canales_autorizados = data.canales_autorizados.split(',');
        // } else {
        //   data.canales_autorizados = [];
        // }
        // if (data.operadores_autorizados) {
        //   data.operadores_autorizados = data.operadores_autorizados.split(',');
        // } else {
        //   data.operadores_autorizados = [];
        // }
        this.$nextTick(() => {
          this.logDatos = this.getLogDatos(data);
          this.form = data;
          console.log('----------form----------------------');
          console.log(this.form);
          console.log('------------------------------------');
        });
      } else {
        this.form = {
          identificador: '',
          id_entidad: '',
          // descripcion: '',
          operadores_autorizados: [],
          canales_autorizados: [],
          estado: ''
        };
      }
      if (form) {
        this.$store.commit('openModal');
      }
    },
    save () {
      if (this.$refs.form.validate()) {
        let data = Object.assign({}, this.form);
        // data.canales_autorizados = data.canales_autorizados.join(',');
        // data.operadores_autorizados = data.operadores_autorizados.join(',');
        if (data.id) {
          let id = data.id;
          delete data.id;
          this.$service.put(`${this.url}/${id}`, data)
          .then(response => {
            if (response) {
              this.$message.success(`¡Datos Actualizados!`, null, { timeout: 2000 });
              // this.$message.success('Se actualizó el registro correctamente');
              this.$store.commit('closeModal');
              this.updateList();
            }
          });
        } else {
          data.estado = 'ACTIVO';
          this.$service.put(`${this.url}`, data)
          .then(response => {
            if (response) {
              this.$message.success(`¡Registro Creado!`, null, { timeout: 2000 });
              this.$store.commit('closeModal');
              this.updateList();
            }
          });
        }
      }
    },
    removerOperador (item) {
      this.form.operadores_autorizados.splice(this.form.operadores_autorizados.indexOf(item), 1);
      this.form.operadores_autorizados = [...this.form.operadores_autorizados];
    },
    removerCanal (item) {
      this.form.canales_autorizados.splice(this.form.canales_autorizados.indexOf(item), 1);
      this.form.canales_autorizados = [...this.form.canales_autorizados];
    }
  },
  components: {
    CrudTable,
    LogDatos
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/puntos_atencion/PuntoAtencion.vue